import { TextStyling } from '@thg-commerce/gravity-patterns'
import { theme } from '@thg-commerce/gravity-theme'
import { Property } from 'csstype'

export type ReferralStepGuideInterface = {
  backgroundColor: Property.Color
  title: TextStyling
  subtitle: TextStyling
  stepSubtitle: TextStyling
  stepText: TextStyling
  svgFill: Property.Color
  smallPrint: TextStyling
}

export const ReferralStepGuideTheme: ReferralStepGuideInterface = {
  backgroundColor: '#FFFFFF',
  title: {
    entry: 'xlarge1',
    style: 'alternate',
    transform: 'none',
    textDecoration: 'none',
    textColor: theme.colors.palette.greys.darker,
  },
  subtitle: {
    entry: 'large1',
    style: 'alternate',
    transform: 'none',
    textDecoration: 'none',
    textColor: theme.colors.palette.greys.darker,
  },
  stepSubtitle: {
    entry: 'large1',
    style: 'alternate',
    transform: 'none',
    textDecoration: 'none',
    textColor: theme.colors.palette.greys.darker,
  },
  stepText: {
    entry: 'bodyText',
    style: 'default',
    transform: 'none',
    textDecoration: 'none',
    textColor: theme.colors.palette.greys.darker,
  },
  smallPrint: {
    entry: 'bodyText',
    style: 'default',
    transform: 'none',
    textDecoration: 'none',
    textColor: theme.colors.palette.greys.darker,
  },
  svgFill: theme.colors.palette.greys.darker,
}
